import { createSelector } from "@reduxjs/toolkit";
import selectAnnotationReducer from "./annotationReducerSelector";
import { RootState } from "../../app";

type Props = {
  entityTypeId: string;
};

const selectEntityId = (_: RootState, props: Props) => props.entityTypeId;

const lastIndexForEntityIdSelector = createSelector(
  [selectAnnotationReducer, selectEntityId],
  (annotations, entityId): number => {
    if (!annotations.length) {
      return 0;
    }

    return Math.max(
      ...annotations
        .filter((annotation) => annotation.entity.id === entityId)
        .map((annotation) => annotation.index || 0),
    );
  },
);

export default lastIndexForEntityIdSelector;
